import numeral from 'numeral';

const ACTIONS = {
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    GET_INFO_TEAM_PUBLIC_SUCCESS: 'GET_INFO_TEAM_PUBLIC_SUCCESS',
    GET_INFO_TEAM_PUBLIC_ERROR:   'GET_INFO_TEAM_PUBLIC_ERROR',
    GET_TEAM_START_MEMBER_SUCCESS: 'GET_TEAM_START_MEMBER_SUCCESS',
    GET_TEAM_START_MEMBER_ERORR: 'GET_TEAM_START_MEMBER_ERORR',
    GET_INFO_TEAM_1_SUCCESS: 'GET_INFO_TEAM_1_SUCCESS',
    GET_INFO_TEAM_1_ERROR: 'GET_INFO_TEAM_1_ERROR',
    GET_TEAM_STARTER_SUCCESS: 'GET_TEAM_STARTER_SUCCESS',
    GET_TEAM_STARTER_ERROR: 'GET_TEAM_STARTER_ERROR'
};



const headerPitcher = [
    {
        name: '背番号',
        name_s:'uniform_number'
    },{
        name: '選手',
        name_s:'player_name'
    },{
        name: '試合',
        name_s:'g'
    },{
        name: '完投',
        name_s:'cg'
    },{
        name: '当初',
        name_s:'tosho'
    },{
        name: '完封',
        name_s:'sho'
    },{
        name: '無四球',
        name_s:'mushikyu'
    },{
        name: '勝数',
        name_s:'w'
    },{
        name: '負数',
        name_s:'l'
    },{
        name: 'セーブ',
        name_s:'sv'
    },{
        name: 'ホールド',
        name_s:'hld'
    },{
        name: 'HP',
        name_s:'hp'
    },{
        name: '勝率',
        name_s:'wpct'
    },{
        name: '投球回',
        name_s:'ip'
    },{
        name: '打者',
        name_s:'bf'
    },{
        name: '打数',
        name_s:'ab'
    },{
        name: '被安打',
        name_s:'h'
    },{
        name: '被本塁打',
        name_s:'hr'
    },{
        name: '与四球',
        name_s:'bb'
    },{
        name: '与死球',
        name_s:'hbp'
    },{
        name: '奪三振',
        name_s:'so'
    },{
        name: '暴投',
        name_s:'wp'
    },{
        name: 'ボーク',
        name_s:'bk'
    },{
        name: '失点',
        name_s:'r'
    },{
        name: '自責点',
        name_s:'er'
    },{
        name: '防御率',
        name_s:'era'
    },{
        name: 'BB/9',
        name_s:'bb_9'
    },{
        name: 'K/9',
        name_s:'k9'
    },{
        name: 'K/BB',
        name_s:'k_bb'
    },{
        name: 'WHIP',
        name_s:'whip'
    },{
        name: '1軍復帰',
        name_s:'comback_date'
    }];

const mockDataPitchingTable2 = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
            { text: '314' },
        ],
    },
];
const headerTeam = ['公示日', 'チーム', 'ポジション | 背番号 | 選手名', '選手動向名'];
const dataPublic = [
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
    {
        item: [
            { text: '2019年4月19日(金)' },
            { text: '巨人', img: '/img/team/Giants.png' },
            { text: '63 増田 大輝', position: '内' },
            { text: '1軍登録' },
        ],
    },
];

const headerAppointment = ['順位', '選手名', '打率'];

const titleSlapTable = {
    dot: false,
    text: '代打',
};
const mockDataSlapTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const titleSprintTable = {
    dot: false,
    text: '代走',
};
const mockDataSprintTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const titleRescueTable = {
    dot: false,
    text: '救援',
};
const mockDataRescueTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const headerSchedule = ['試合日', '開始時間/スコア', '球場', '勝利投手', 'セーブ投手', '敗戦投手', '観衆'];

const dataSchedule = [
    {
        item: [
            { text: '4/19(金)' },
            { text: 'G 5 - 2 T' },
            { text: '東京ドーム' },
            { text: '山口　俊' },
            { text: 'デラロサ' },
            { text: '西 勇輝' },
            { text: '45,277' },
        ],
    },
    {
        item: [
            { text: '4/19(金)' },
            { text: 'G 5 - 2 T' },
            { text: '東京ドーム' },
            { text: '' },
            { text: '' },
            { text: '' },
            { text: '' },
        ],
    },
    {
        item: [
            { text: '4/19(金)' },
            { text: 'G 5 - 2 T' },
            { text: '東京ドーム' },
            { text: '' },
            { text: '' },
            { text: '' },
            { text: '' },
        ],
    },
];

const boardItems = [
    {
        subText: '順位',
        mainText: '1',
    },
    {
        subText: '勝数',
        mainText: '77',
    },
    {
        subText: '負数',
        mainText: '64',
    },
    {
        subText: '引分数',
        mainText: '2',
    },
    {
        subText: '勝率',
        mainText: '.546',
    },
    {
        subText: '監督',
        mainText: '原 辰徳',
    },
];

const headerStart1 = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const dataTableStart1 = [
    {
        item: [
            { text: '亀井', position: '右' },
            { text: '坂本勇', position: '遊' },
            { text: '丸', position: '中' },
            { text: '岡本', position: '三' },
            { text: '阿部', position: '一' },
            { text: 'ゲレーロ', position: '左' },
            { text: '田中俊', position: '二' },
            { text: '小林', position: '捕' },
            { text: '山口', position: '投' },
        ],
    },
];

const headerStart2 = [
    {
        text: '投手',
        width: '30%'
    },
    {
        text: '代打',
        width: '20%'
    },
    {
        text: '代走',
        width: '20%'
    },
    {
        text: '守備固め',
        width: '20%'
    },
    {
        text: '相手先発投手',
        width: '10%'
    }];
const dataTableStart2 = [
    {
        item: [
            { text: '山口・中川・デラロサ・田口', position: '右' },
            { text: '若林', position: '守' },
            { text: '望月', position: '捕' },
        ],
    },
];

export default (state = {
    headerPitcher,
    mockDataPitchingTable2, headerTeam, dataPublic,
    headerAppointment, titleSlapTable, mockDataSlapTable,
    titleSprintTable, mockDataSprintTable, titleRescueTable,
    mockDataRescueTable, headerSchedule, dataSchedule,
    headerStart1, dataTableStart1, headerStart2, dataTableStart2,
    boardItems
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_SUCCESS:
        case ACTIONS.GET_INFO_TEAM_PUBLIC_SUCCESS:
        case ACTIONS.GET_TEAM_STARTER_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_TEAM_START_MEMBER_SUCCESS:
            [
                boardItems[0].mainText,
                boardItems[1].mainText,
                boardItems[2].mainText,
                boardItems[3].mainText,
                boardItems[4].mainText,
                boardItems[5].mainText,

            ] =
            [
                action.data.rank,
                action.data.w,
                action.data.l,
                action.data.t,
                numeral(action.data.wpct).format('0.000').toString().substr(1),
                action.data.field_manager.player_name
            ];
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_INFO_TEAM_1_SUCCESS:
                return {
                    ...state,
                    status: action.type,
                    response: action.data,
                };
        case ACTIONS.GET_TEAM_STARTER_ERROR:
        case ACTIONS.GET_INFO_TEAM_1_ERROR:
        case ACTIONS.GET_INFO_TEAM_PUBLIC_ERROR:
        case ACTIONS.GET_TEAM_START_MEMBER_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};
